import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import deleteIcon from "../assets/delete.svg";
import edit from "../assets/edit.svg";
import history from "../assets/history.svg";
import * as actions from "../Store/_redux/LeaveStore/leaveAction";
import * as userAction from "../Store/_redux/UserStore/userActions";
import TransactionsModal from "./modal/LeaveTransactionsModal.jsx";
import UserEditModal from "./modal/UserEditModal";

export default function UserCard({ index, user, refresh }) {
  const dispatch = useDispatch();
  const transactions = useSelector((state) => state.leave.transactions || []);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isTransactionsModalOpen, setIsTransactionModalOpen] = useState(false);

  const handleDelete = async (user) => {
    const confirmed = window.confirm(
      "Bu kullanıcıyı silmek istediğinize emin misiniz?"
    );
    if (!confirmed) return;

    const response = await dispatch(userAction.deleteUser(user));
    if (response) refresh();
  };

  const handleTransactions = async () => {
    await dispatch(actions.getLeaveTransactions(user.tc));
    setIsTransactionModalOpen(true);
  };

  const handleEdit = () => setIsEditModalOpen(true);

  return (
    <div
      className={`flex px-4 py-4 justify-between mb-3 ${
        index % 2 === 0 ? "bg-white" : "bg-input-bg"
      }`}
    >
      <div>
        <h3 className="font-bold text-lg">
          {user.name} {user.surname}
        </h3>
        <p className="text-gray-600">{user.tc}</p>

        {/*  Mevcut izin (kalan gün) bilgisi */}
        <p className="text-blue-600 text-sm mt-1 font-medium">
          Mevcut izin:{" "}
          {user?.remainingLeaveDays !== undefined && user?.remainingLeaveDays !== null
            ? Number(user.remainingLeaveDays)
            : "Bilgi yok"}
        </p>
      </div>

      <div className="mt-2 flex gap-2">
        <button type="button" onClick={handleTransactions}>
          <img className="text-black fill-black" alt="" src={history} />
        </button>
        <button
          onClick={handleEdit}
          type="button"
          className="bg-select-b border-select-b border-[1px] px-2 h-10 rounded-md text-white"
        >
          <img src={edit} alt="" />
        </button>
        <button
          onClick={() => handleDelete(user)}
          type="button"
          className="bg-red-500 px-2 h-10 rounded-md text-white"
        >
          <img src={deleteIcon} alt="" />
        </button>
      </div>

      <UserEditModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        user={user}
        refresh={refresh}
      />
      <TransactionsModal
        isOpen={isTransactionsModalOpen}
        onClose={() => setIsTransactionModalOpen(false)}
        transactions={transactions}
      />
    </div>
  );
}
